import { axios } from '@/utils/axios';
import type { ProfileChangeMetadata, ProfileChangeRequest, ProfileChangeValues } from '@/types/profileChanges';

interface Response<T> { success: boolean; data: T; message: string }
const base = '/api/profile-change-requests';
export const getProfileChangeMetadata = () => axios.get<Response<ProfileChangeMetadata>>(`${base}/metadata`);
export const getProfileChangeRequests = () => axios.get<Response<{ items: ProfileChangeRequest[] }>>(base);
export const createProfileChangeRequest = (changes: ProfileChangeValues, reason: string, status: 'draft' | 'pending', evidence?: File) => {
  if (!evidence) return axios.post<Response<ProfileChangeRequest>>(base, { changes, reason, status });
  const data = new FormData();
  data.append('changes', JSON.stringify(changes));
  data.append('reason', reason);
  data.append('status', status);
  data.append('evidence', evidence);
  return axios.post<Response<ProfileChangeRequest>>(base, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const withdrawProfileChangeRequest = (id: number) => axios.post<Response<ProfileChangeRequest>>(`${base}/${id}/withdraw`);
export const submitProfileChangeRequest = (id: number) => axios.post<Response<ProfileChangeRequest>>(`${base}/${id}/submit`);
export const downloadProfileChangeEvidence = (id: number) => axios.get<Blob>(`${base}/${id}/evidence`, { responseType: 'blob' });
